import get from 'lodash/get'

export const isEditingImage = (state) => get(state, ['vegetation', 'editor', 'editing'])
export const getEditingImage = (state) => get(state, ['vegetation', 'editor', 'image'])
export const getEditingInspectionId = (state) => get(state, ['vegetation', 'editor', 'inspectionId'])
export const getEditingVisitId = (state) => get(state, ['vegetation', 'editor', 'visitId'])
export const getEditorToobarOpen = (state) => get(state, ['vegetation', 'editor', 'toolbarOpen'])
export const getSelectedTool = (state) => get(state, ['vegetation', 'editor', 'tool'])
export const isDrawingLine = (state) => get(state, ['vegetation', 'editor', 'drawingLine'])
export const isSavingEditor = (state) => get(state, ['vegetation', 'editor', 'saving'])


// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/editor.js